import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { MatPaginator } from '@angular/material/paginator';
import { PAGE_SIZE_OPTIONS, PAGE_LENGTH, ITEMS_PER_PAGE, CURRENT_PAGE } from 'src/app/shared/constants/pagination.constants';
import { AttendancesService } from '../../services/attendances.service';
import { Attendance } from '../../models/attendance';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { LoaderService } from 'src/app/auth/services/loader.service';

@Component({
  selector: 'app-attendances-details',
  templateUrl: './attendances-details.component.html',
  styleUrls: ['./attendances-details.component.css']
})
export class AttendancesDetailsComponent implements OnInit,AfterViewInit {
  @ViewChild('paginator', {static: true}) paginator: MatPaginator;

  public weekStatusDisplayedColumns: string[] = ['org_name', 'name','type', 'event_type','working_on','event_date_time','event_location'];
  public weekStatusDataSource:any;
  
  public PAGE_SIZE_OPTIONS_DATA:number[] = PAGE_SIZE_OPTIONS;
  
  public page_length:number = PAGE_LENGTH;
  
  public items_per_page:number = ITEMS_PER_PAGE;
  
  public current_page:number = CURRENT_PAGE;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private attendanceService:AttendancesService,
    private loaderService:LoaderService
    ) { }

  ngOnInit(): void {
    this.loadIcon();
    this.getAttendance();
  }

  ngAfterViewInit(){
    if(this.weekStatusDataSource != undefined){
      this.weekStatusDataSource.paginator  = this.paginator;
    }
  }
  
  getAttendance():void{
    this.loaderService.isTableLoding.next(true);
    
    let filterParams = this.addFilterParameters();

    this.attendanceService.getAttendance(filterParams).subscribe(
      (res)=>{
        this.loaderService.isTableLoding.next(false);
        this.page_length = res.headers.get('X-Pagination-Total-Count');
        this.current_page = res.headers.get('X-Pagination-current-page');
        this.items_per_page = res.headers.get('X-Pagination-Per-Page');
        this.weekStatusDataSource = new MatTableDataSource<any>(res.body);
        console.log(res.body);
      }
    );
  }

  loadIcon(){
    this.matIconRegistry.addSvgIcon(
      "filter",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/SVG/filter.svg")
    );
  }
  
  addFilterParameters(){
    let filterParams = {};
    filterParams['page']=this.current_page;
    filterParams["per-page"]=this.items_per_page;
    filterParams["sort"] = "-id";
    return filterParams;
  }


  handlePage(e?: any):void {
    if(e){
      this.current_page = e.pageIndex+1;
      this.items_per_page = e.pageSize;
      this.page_length = e.length;
    }
    this.getAttendance();
  }

}

